.card {
  border-radius: 4px;
  background: transparent;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;

  &:last-of-type {
    margin-bottom: 0;
  }
}

.previewImg {
  width: 100%;
  height: 180px;
  object-fit: cover;
  aspect-ratio: 1 / 2;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.innerCard {
  border: 1px solid #b3b3b3;
  background: transparent;
  border-radius: 16px;
  width: 100%;
  min-height: 180px;
  padding: 15px 15px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

.innerCardWithImage {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-top: none;
}

.expand {
  svg {
    height: 20px;
    width: auto;
  }
  .iconButton {
    transition: all 0.3s ease;
    padding: 7px 13px;
    border-radius: 12px;
  }
  .iconButton:hover {
    background: #f1f1f1;
  }
  // position: absolute;
  // right: 8px;
  // top: 8px;
  display: flex;
  gap: 16px;
  width: calc(100% - 18px);
  align-items: center;
  justify-content: space-between;
  // border-top: 1px solid #2b2b2b57;
  margin-top: 15px;
  padding-top: 10px;
}

.username {
  color: #00000063;
  cursor: pointer;
  transition: color .2s;

  &:hover {
    color: #3b3b3b;
  }
}

.hint {
  font-size: 16px;
  color: #969696;
  font-weight: 300;
}

.icon {
  &:hover {
    color: #3b3b3b;
    fill: #3b3b3b;
  }

  transition: all .2s!important;
  cursor: pointer;
}

.selectedQuestion .innerCardWithImage, .selectedQuestion .innerCard {
  border-width: 2px;
  margin-bottom: 30px;

  &::after {
    content: "⬤";
    color: #bebebe;
    font-size: 6px;
    position: absolute;
    bottom: -25px;
    right: 50%;
    transform: translateX(-50%);
  }
}

.badge {
  color: #3b3b3b;
  text-align: left;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  // font-family: IBM Plex Sans, sans-serif;

  span {
    background: #bebebe;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    box-sizing: border-box;
    display: block;
    text-align: center;
    width: 87px;
    padding-bottom: 7px;
    padding-top: 5px;
    margin-bottom: -3px;
    font-family: IBM Plex Sans, sans-serif;
    font-size: 16px;
    font-weight: 300;
  }
}

.selectedQuestion .previewImg {
  border: 2px solid #b3b3b3;
  border-bottom: none;
}

// .icon-container {
//   position: relative;
//   display: inline-block;
//   width: 64px; /* Adjust based on your icon size */
//   height: 64px;
// }

// .icon {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   transition: opacity 0.5s ease-in-out;
// }

// .fadeIn {
//   opacity: 1;
// }

// .fadeOut {
//   opacity: 0;
// }

.vennDiagramIcon path {
  transition: fill 0.5s ease-in-out;
}

.commentText:hover {
  color: #4b4949!important;
}

.textarea {
  &::placeholder {
      color: #2b2b2b8e;
      font-size: 16px;
  }
  font-family: inherit;
  box-sizing: border-box;
  border: none;
  outline: none;
  caret-color: #969696;
  color: #2b2b2b;
  border-radius: 4px;

  resize: none;
  padding: 10px 15px;

  height: 144px;
  width: 100%;
  // box-shadow: 0px 3px 3.84px 2.16px rgba(12, 12, 12, 0.17);
  font-size: 16px;
  // font-family: 'IBM Plex Sans';


    background: #2b2b2b0f;
    // box-shadow: 0 3px 3.84px 2.16px #0c0c0c2b;
  &:disabled {
    cursor: not-allowed;
  }
}

.button {
  // font-family: IBM Plex Sans, sans-serif;
  cursor: pointer;
  border: none;
  outline: none;
  justify-content: center;
  align-items: center;
  transition: box-shadow .3s ease-out;
  display: flex;
  position: absolute;
  bottom: -5px;
  right: 5px;
  transform: translateY(-50%);

    border-radius: 16px;
    font-weight: 400;
    font-size: 16px;
    height: 36px;
    width: 72px;
    border: 1px solid #b5b5b5;
    background: transparent;
    color: #121212;
    transition: background 0.3s ease;
}

.button:not(:disabled):hover {
  // box-shadow: 0 3px 9.84px -0.84px #3eb5f12e;
  background: white;
  cursor: pointer;
}

.button:disabled {
  // background: #8d9193;
  cursor: not-allowed;
  // box-shadow: 0 0 23.84px 8.16px #8d91935c;
}

.text {
  font-size: 18px;
  font-weight: 300;
  color: #bebebe;
}
